module.exports = __webpack_public_path__ + "media/images/svg/add-person-1e74ef0bdf527ffefea291758114d57f.svg";